import { render, staticRenderFns } from "./BeneficioForm.vue?vue&type=template&id=99961250&scoped=true&"
import script from "./BeneficioForm.vue?vue&type=script&lang=js&"
export * from "./BeneficioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99961250",
  null
  
)

export default component.exports